import { SagaIterator } from "redux-saga";
import { takeEvery, put, call } from "redux-saga/effects";
import { doc, setDoc, getDoc, updateDoc } from "~/utils/firebase/firestore";

import { database } from "<config>/firebase";
import { getDeepLinksCollection } from "~/constants/collections";
import { logError } from "~/utils/logger";

import { saveReferral, getReferral } from "./actions";
import { setReferral } from "./slice";
import { SaveReferralAction, DeepLinksReferral } from "./types";
import { getIpAddress } from "~/utils/network";

export const saveReferralSaga = function* ({
  payload,
}: SaveReferralAction): SagaIterator {
  const { referral, path } = payload;

  try {
    const deepLinksCollection = getDeepLinksCollection();
    const now = new Date().toISOString();
    const ipAddress = yield call(getIpAddress);

    const referralData: DeepLinksReferral = {
      ipAddress,
      referral,
      path,
      createdAt: now,
      updatedAt: now,
      opened: false,
    };

    yield call(
      setDoc,
      doc(database, deepLinksCollection, ipAddress),
      referralData
    );

    yield put(setReferral(referralData));
  } catch (error) {
    logError(error);
  }
};

export const getReferralSaga = function* (): SagaIterator {
  try {
    const deepLinksCollection = getDeepLinksCollection();
    const ipAddress = yield call(getIpAddress);

    const docRef = doc(database, deepLinksCollection, ipAddress);
    const docSnap = yield call(getDoc, docRef);

    if (docSnap.exists()) {
      const referralData = docSnap.data() as DeepLinksReferral;
      if (referralData.opened) {
        return;
      }
      yield put(setReferral(referralData));
      yield call(updateDoc, docRef, { opened: true });
    } else {
      yield put(setReferral(null));
    }
  } catch (error) {
    logError(error);
  }
};

export const deepLinksSaga = function* (): SagaIterator {
  yield takeEvery(saveReferral.type, saveReferralSaga);
  yield takeEvery(getReferral.type, getReferralSaga);
};
